import React from "react";
import ContactForm from "./contact_form";
import "./contacts_layout.css";
import { PHONE_NUMBER } from './config';


function ContactSection() {
  return (
    <div className="contact-section" id="contact-section">
      <h2 className="contact-section-title">OUR CONTACTS</h2>
      <div className="contact-section-row">
      <div className="contacts-info-col">
      <a href={`tel:${PHONE_NUMBER}`} className="number-title">
        <h2 className="number-title">{PHONE_NUMBER}</h2> </a>
        <span className="email-address-c">
        <a href="mailto:example@gmail.com" className="email-link-c">example@gmail.com</a>
        </span>
        <p><strong>Service areas:</strong> San Diego</p>
      </div>

      <div className="form-col">
        <ContactForm isModal={false} />
      </div>
    </div>
    </div>
  );
}

export default ContactSection;